/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { defaultCreateAppData, ICreateAppData } from './IAppModels'
import AutoCompleteAddress from '../../../helpers/components/AutoCompletePlace'
import { StepperComponent } from '../../../assets/ts/components'
import { isNotEmpty, KTIcon } from '../../../helpers'
// import {Step1} from './steps/Step1'
// import {Step2} from './steps/Step2'
// import {Step3} from './steps/Step3'
// import {Step4} from './steps/Step4'
// import {Step5} from './steps/Step5'
import { useFormik } from 'formik'
import { errorToast, successToast } from '../../../helpers/components/Toaster'
import {
  createUser,
  updateUser,
} from '../../../../app/modules/apps/data-administration/data-admininstration-list/core/_requests'
import { useListView } from '../../../../app/modules/apps/data-administration/data-admininstration-list/core/ListViewProvider'
import { useQueryResponse } from '../../../../app/modules/apps/data-administration/data-admininstration-list/core/QueryResponseProvider'
import * as Yup from 'yup'
import clsx from 'clsx'
import PasswordFormField from '../../../../app/modules/accounts/components/settings/cards/PasswordFiledForm'
import { UsersListLoading } from '../../../../app/modules/apps/data-administration/data-admininstration-list/components/loading/UsersListLoading'
import CountryDropDown from '../../../helpers/countryDropDown'
import { useAuth } from '../../../../app/modules/auth'

type Props = {
  show: boolean
  handleClose: () => void
  user?: any
  isUserLoading?: boolean
}
const editUserSchema = (id) =>
  Yup.object().shape({
    // name: Yup.string()
    //   .min(3, 'Minimum 3 symbols')
    //   .max(50, 'Maximum 50 symbols')
    //   .required('Name is required'),
    // password: Yup.string().required('Password Required'),
    // confirm_password: Yup.string()
    //   .label('confirm password')
    //   .required()
    //   .oneOf([Yup.ref('password'), 'Passwords must match'], 'Passwords must match'),
    // mobileNumber: Yup.string()
    //   .matches(/^\d*$/, 'Only numbers are allowed')
    //   .trim('White space not allowed')
    //   .strict(true)
    //   .min(3, 'Minimum 3 symbols')
    //   .max(15, 'Maximum 50 symbols')
    //   .required('Mobile Number is required'),
    // email: Yup.string()
    //   .email('Invalid email address') // Custom error message
    //   .required('Email is required'),
  })

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({ show, handleClose, user = {}, isUserLoading }: Props) => {
  const { currentUser }: any = useAuth()

  const stateCodeMapping = {
    'Andaman and Nicobar Islands': 'AN',
    'Andhra Pradesh': 'AP',
    'Arunachal Pradesh': 'AR',
    'Assam': 'AS',
    'Bihar': 'BH',
    'Chandigarh': 'CH',
    'Chhattisgarh': 'CT',
    'Dadra and Nagar Haveli': 'DN',
    'Daman and Diu': 'DD',
    'Delhi': 'DL',
    'Goa': 'GA',
    'Gujarat': 'GJ',
    'Haryana': 'HR',
    'Himachal Pradesh': 'HP',
    'Jammu and Kashmir': 'JK',
    'Jharkhand': 'JH',
    'Karnataka': 'KA',
    'Kerala': 'KL',
    'Lakshadweep': 'LD',
    'Madhya Pradesh': 'MP',
    'Maharashtra': 'MH',
    'Manipur': 'MN',
    'Meghalaya': 'ME',
    'Mizoram': 'MI',
    'Nagaland': 'NL',
    'Odisha': 'OR',
    'Puducherry': 'PY',
    'Punjab': 'PB',
    'Rajasthan': 'RJ',
    'Sikkim': 'SK',
    'Tamil Nadu': 'TN',
    'Telangana': 'TS',
    'Tripura': 'TR',
    'Uttar Pradesh': 'UP',
    'Uttarakhand': 'UT',
    'West Bengal': 'WB'
  };

  const [address, setAddress] = useState('')
  const [location, setLocation] = useState({ lat: 0, lng: 0 })

  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<ICreateAppData>(defaultCreateAppData)
  const [firstRun, setfirstRun] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [userForEdit, setUserForEdit] = useState<any>({
    ...user,
    name: user?.personalDetails?.name || '',
    email: user?.personalDetails?.email || '',
    countryCode: user?.address?.country || '',
    mobileNumber: user?.personalDetails?.mobile || '',
  })

  useEffect(() => {
    if (Object.keys(user).length > 0 && firstRun) {
      setUserForEdit({
        id: user.id,
        name: user?.personalDetails?.name || '',
        email: user?.personalDetails?.email || '',
        countryCode: user?.address?.country || '',
        mobileNumber: user?.personalDetails?.mobile || '',
      })
      setfirstRun(false)
    }
  }, [firstRun, user])

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const handleModalClose = () => {
    setfirstRun(true)
    handleClose()
  }

  const formik: any = useFormik({
    initialValues: userForEdit,
    enableReinitialize: true,
    validationSchema: editUserSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        console.log('test')
        // const payload = {
        //   ...currentUser,
        //   address: [
        //     ...currentUser.address,
        //     {
        //       addressType: 'DELIVERY_ADDRESS',
        //       latitute: null,
        //       longitute: null,
        //       street: values?.address?.street,
        //       country: values?.country,
        //       countryCode: null,
        //       city: values?.city,
        //       zipCode: '1213',
        //       state: values?.state,
        //     },
        //   ],
        // }
        // const payload =
        //   [{
        //     addressType: 'DELIVERY_ADDRESS',
        //     // latitute: null,
        //     // longitute: null,
        //     street: values?.address?.street,
        //     country: values?.country,
        //     // countryCode: null,
        //     city: values?.city,
        //     // zipCode: '1213',
        //     state: values?.state,
        //   }]





        // const payload = {
        //   address: [
        //     {
        //       addressType: 'DELIVERY_ADDRESS',
        //       street: values?.address?.street,
        //       country: values?.country,
        //       city: values?.city,
        //       state: values?.state,
        //       zipCode: null,
        //     },
        //   ],
        //   userType: 'RECYCLER',
        // }

        const payload = {
          address: [
            {
              addressType: 'DELIVERY_ADDRESS',
              street: address,
              country: values?.country,
              city: values?.city,
              state: values?.state,
              stateCode: stateCodeMapping[values?.state] || '', // Add this line
              zipCode: null,
              latitute: location.lat,
              longitute: location.lng,
            },
          ],
          userType: 'RECYCLER',
        }

        console.log({ payload, values })
        await updateUser(payload, `users/${currentUser.id}/updateAddress`)
        successToast('Modified')
        handleModalClose()
        window.location.reload()
      } catch (ex: any) {
        console.log({ ex: ex?.response?.data?.data, exxx: ex })
        errorToast(ex?.response?.data?.data || 'Something Went Wrong')
        console.error(ex)
      } finally {
        setSubmitting(false) // Changed from true to false to properly end loading state
      }
    },
  })




  // Add this useEffect to watch for state changes
  useEffect(() => {
    if (formik.values.state && formik.values.country === 'India') {
      const code = stateCodeMapping[formik.values.state];
      if (code) {
        formik.setFieldValue('stateCode', code);
      }
    }
  }, [formik.values.state, formik.values.country]);





  useEffect(() => {
    // When address is set from AutoCompleteAddress, make sure location is also updated
    if (address && (!location.lat || !location.lng)) {
      // If address exists but no coordinates, try to geocode
      if (window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === 'OK' && results && results[0] && results[0].geometry) {
            const loc = results[0].geometry.location;
            const coords = {
              lat: loc.lat(),
              lng: loc.lng()
            };
            setLocation(coords);
          }
        });
      }
    }
  }, [address, location.lat, location.lng]);





  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleModalClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>Add Manager</h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
          <KTIcon className='fs-1' iconName='cross' />
        </div>
        {/* end::Close */}
      </div>

      <form
        id='kt_modal_add_user_form'
        className='form p-10'
        onSubmit={formik.handleSubmit}
        noValidate
      >
        {/* <div className='fv-row mb-7'>
          <label className='required fw-bold fs-6 mb-2'>Street</label>
          <input
            style={{background: 'white', border: '1px solid #cccccc'}}
            placeholder='Enter Street Address'
            {...formik.getFieldProps('street')}
            type='text'
            name='address.street'
            className={clsx(
              'form-control form-control-solid mb-3 mb-lg-0',
              {'is-invalid': formik.touched.street && formik.errors.street},
              {'is-valid': formik.touched.street && !formik.errors.street}
            )}
            autoComplete='off'
            disabled={formik.isSubmitting || isUserLoading}
          />
          {formik.touched.street && formik.errors.street && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.street}</span>
              </div>
            </div>
          )}
        </div> */}



        <div className='fv-row mb-7'>
          <label className='required fw-bold fs-6 mb-2'>Street Address</label>
          <AutoCompleteAddress
            formik={formik}
            address={address}
            setAddress={setAddress}
            location={location}
            setlocation={setLocation}
          />
          {formik.touched.street && formik.errors.street && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.street}</span>
              </div>
            </div>
          )}
        </div>

        <CountryDropDown showState showCity name='country' formik={formik} showNameOnly />

        {/* Form Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => handleModalClose()}
            className='btn me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
            style={{ backgroundColor: '#dc3545', color: 'white' }}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn'
            data-kt-users-modal-action='submit'
            style={{ backgroundColor: '#28a745', color: 'white' }}
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </Modal>,
    modalsRoot
  )
}

export { CreateAppModal }
